/**
 * Small pure helpers shared across the ReviewOrderPage split.
 *
 * Kept tiny on purpose — anything that grows beyond a couple of lines
 * should move to its own module.
 */

/**
 * Map a free-text country string to the 2-letter ISO code consumed by the
 * Freightcom shipping API. Defaults to 'CA' so a missing country doesn't
 * block rate fetches for orders placed from a Canadian browser.
 */
export const countryToIso = (country) => {
  const c = (country || '').toLowerCase();
  if (c.includes('canad')) return 'CA';
  if (c.includes('states')) return 'US';
  return 'CA';
};

/**
 * Label for the version chip under "Preview My Sticker". Decorated with
 * the foil choice so v01 (gold) vs v02 (rose) is obvious at a glance.
 */
export const buildVersionLabel = (order, index) => {
  const n = String(index + 1).padStart(2, '0');
  const foil = order?.foil_type;
  const hex = order?.foil_color_hex;
  if (foil === 'colored' && hex) return `v${n} (${hex})`;
  if (foil && foil !== 'none') return `v${n} (${foil})`;
  return `v${n}`;
};
